import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageSide300x250Gak from './gak/MobileDevPageSide300x250';
import MobileDevPageSide300x250Hashtag from './hashtag/MobileDevPageSide300x250';
const MobileDevPageSide300x250 = ({ safety ='off' , safetyState  })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
